import noop from 'lodash/noop'
import { createContext } from 'react'

interface Controller {
  disableDrag: (value: boolean) => void
  isDragDisabled: boolean
  isZoomedIn: boolean
  setZoomedIn: (value: boolean) => void
}

export const ControllerContext = createContext<Controller>({
  isDragDisabled: false,
  disableDrag: noop,
  isZoomedIn: false,
  setZoomedIn: noop,
})
